import { isEmpty, isString, get, isPlainObject, defaultTo } from 'lodash';

// loacl dependencies
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';
import { BLANK_VALUE_SYMBOL, GLOBAL_LABELS } from 'constants/common';

// get store
const store = getStore();

// provide global value from the redux store
const provideGlobalPlaceholderValue = ( key ) => {
	const LABELS = store.getState()[ REDUCER.LABELS ];
	const CALL_STATE = store.getState()[ REDUCER.CALL_STATE ];

	switch( key ) {

		// `Caller` or `Callee` word
		case 'callerCallee': {

			// return `Callee` word if no call is ongoing or `callerType` is '2'
			if( isEmpty( CALL_STATE ) || ( '2' === CALL_STATE.callerType ) ) {
				return LABELS[ GLOBAL_LABELS.DISPLAY_TEXT_CALLEE ];
			}

			// return `Caller` word
			return LABELS[ GLOBAL_LABELS.DISPLAY_TEXT_CALLER ];
		}

		// return as missing value
		default: {
			return '[missing-value]';
		}
	}
};

/**
 * Replace placeholders.
 * @param {String} value
 * @param {Object} placeholderData
 */
const replacePlaceholders = ( value, placeholderData = {} ) => {
	
	/* if( isEmpty( placeholderData ) ) {
		return value;
	} */

	// find `${...}` patterns
	return value.replace( /\$\{([a-z.]+)\}/gi, ( ...matchData ) => {

		// get matched values
		const matchedPattern = defaultTo( matchData[ 0 ], '' );
		const placeholderKey = defaultTo( matchData[ 1 ], '' );

		// check if `placeholderKey` starts with `global.`
		if( placeholderKey.startsWith( 'global.' ) ) {
			const placeholderVar = placeholderKey.replace( 'global.', '' );
			return provideGlobalPlaceholderValue( placeholderVar );
		}

		// check if `placeholderKey` starts with `local.`
		if( placeholderKey.startsWith( 'local.' ) ) {
			const placeholderVar = placeholderKey.replace( 'local.', '' );
			return get( placeholderData, placeholderVar, '[missing-value]' );
		}

		// return original pattern back
		return matchedPattern;
	} );

};

// extract label from the store
const extractLabelFromStore = ( key, placeholderData = {} ) => {
	const LABELS = store.getState()[ REDUCER.LABELS ];
	const value = get( LABELS, key, BLANK_VALUE_SYMBOL );

	// return black value symbol
	if( value === BLANK_VALUE_SYMBOL ) {
		return value;
	}

	// replace placeholders
	return replacePlaceholders( value, placeholderData );
};

/**
 * @type {function}
 * @desc Extract label from the store.
 * @example
 * import { getLabel } from 'utils/getLabel';
 * const result = getLabel( ...args );
 */
export const getLabel = ( payload = {}, placeholderData = {} ) => {
	if( isEmpty( payload ) ) {

		return BLANK_VALUE_SYMBOL;

	} else if( isString( payload ) ) {

		return extractLabelFromStore( payload, placeholderData ); // if `paylod` is a `string`, it's the label key

	} else if( isPlainObject( payload ) ) {

		if( ! isEmpty( payload.value ) ) {

			return payload.value; // if `payload.value` is not empty, return `value` back

		} else if( isEmpty( payload.refId ) ) {

			return BLANK_VALUE_SYMBOL; // if `payload.refId` is empty, return blank symbol

		}  else {

			return extractLabelFromStore( payload.refId, placeholderData );

		}

	} else {

		return BLANK_VALUE_SYMBOL;

	}
};

/**
 * @type {function}
 * @desc Check if label is empty
 * @example
 * import { isEmptyLabel } from 'utils/getLabel';
 * const result = isEmptyLabel( ...args );
 */
export const isEmptyLabel = ( payload = {} ) => {
	return BLANK_VALUE_SYMBOL === getLabel( payload );
};
